var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webpageWrap preview"},[_c('img',{attrs:{"src":_vm.webpage}}),(_vm.isPreview)?_c('span',{staticClass:"preview-media-badge"},[_vm._v("第 "+_vm._s(_vm.step)+" 步")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }